import { render, staticRenderFns } from "./OptionLoader.vue?vue&type=template&id=ca4ccbfe&"
import script from "./OptionLoader.vue?vue&type=script&lang=js&"
export * from "./OptionLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports